// angular import
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// services import
import { AccountService } from './../../service/accountService.service';
import { Locale } from './../../service/locale.service';
import { ServerMapping } from './../../service/serverMapping.service';
// manager import
import { ModelsManager } from '../../manager/models.manager';
import { GrowlManager } from './../../manager/growl.manager';
import { DownloadManager } from '../../manager/download.manager';
// models import


@Injectable()
export class SupplyDocService {

  private searching = false;
  private docs = [];

  constructor(private accountService:   AccountService,
              private serverMapping:    ServerMapping,
              private growlManager:     GrowlManager,
              private downloadManager:  DownloadManager,
              private locale:           Locale,
              private http:             Http,
              private modelManager:     ModelsManager) {}

  isSearching() { return this.searching; }

  getDocs() { return this.docs; }

  // method wich returns supplier documents list
  searchDocs() {
    if (this.searching === false) {
      this.searching = true;
      this.http.get(this.serverMapping.supplyDocURL +
        '?supplier_code=' + this.modelManager.supply_doc_request.supplier_code +
        '&company_code=' + this.modelManager.supply_doc_request.company_code +
        '&language=' + this.modelManager.supply_doc_request.language).subscribe(
          (response) => {
            const data = response.json();
            if (this.growlManager.checkForErrorInResponse(data)) {
              this.growlManager.showMessagesByResponse(data);
            } else {
              this.docs = data.contained_bean;
            }

            this.searching = false;
          },
          (error) => {
            console.log('--------------------------------');
            console.log('!!!An error has been occurred!!!');
            console.log(error);
            console.log('--------------------------------');
          }
        );
    }
  }

  downloadDocument(docType, docNumber, docVersion, docPart, filePath, fileName) {
    this.http.get(this.serverMapping.docDownloadURL +
      '?doc_type=' + docType +
      '&doc_number=' + docNumber +
      '&doc_version=' + docVersion +
      '&doc_part=' + docPart +
      '&file_path=' + 'filePath' +
      '&file_name=' + fileName).subscribe(
      (response) => {
        const data = response.json();
        if (!data.download) {
        this.growlManager.checkForErrors(data);
        } else {
        this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
        }
        console.log(data);
      },
      (error) => {
        console.log('--------------------------------');
        console.log('!!!An error has been occurred!!!');
        console.log(error);
        console.log('--------------------------------');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/supply-doc/supply-doc.service.ts